import { CustomBuilderComponents } from '@/helpers/enums';
import { buttonSubfields } from '@/components/common/Button/Button.BuilderObj';

export const findPistachiosBuilderConfigs = {
  name: CustomBuilderComponents.FIND_PISTACHIOS,
  image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/globe-alt.svg',
  inputs: [
    {
      name: 'eyebrow',
      type: 'string',
    },
    {
      name: 'title',
      type: 'string',
      required: true,
    },
    {
      name: 'body',
      type: 'customRichTextPistachios',
      required: true,
    },
    {
      name: 'button',
      friendlyName: 'Where to Buy Button',
      type: 'object',
      ...buttonSubfields,
    },
  ],
};
